import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    height: 64,
    padding: [0, 12, 0, theme.spacing(3)],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: theme.palette.colors.white,
    position: 'fixed',
    top: 0,
    zIndex: 100,
  },
  burger: {
    color: theme.palette.colors.teal,
    fontSize: 40,
  },
  call: {
    color: theme.palette.colors.teal,
    textDecoration: 'none',
    fontWeight: 'bold',
    backgroundColor: theme.palette.colors.lightTeal,
    padding: [5, 10],
    borderRadius: 4,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MobileNonAuthHeader/useStyles.js